import config from './config'

/**
 * api对应分组域名配置
 */
const ApiConfig = {
  '/api/gateway_auth/login': config.xmsUrl,
  "/api/checkin/nightAuditorListForXms": config.orderUrl,
  "/api/nightAuditor/oneKeyNightAuditorXms": config.orderUrl,
  "/api/checkin/list": config.orderUrl,
  '/intelligent_reception/api/v1/checkiners/add_to_checkin': config.xmsUrl,
  '/intelligent_reception/api/v1/room_calendar/realtime': config.xmsUrl,
  '/intelligent_reception/api/v1/room_calendar/realtime_agg': config.xmsUrl,
  '/intelligent_reception/api/v1/orders': config.xmsUrl,
  '/intelligent_reception/api/v1/checkin/order_checkin_and_check': config.xmsUrl,
  '/xms/api/pay/charges': config.xmsUrl,
  '/api/v1/room_calendar': config.xmsUrl,
  '/api/checkinInfo/byDateExt': config.orderUrl,
  '/api/checkin/byDateChecnkinExt': config.orderUrl,
  '/api/order/cancel': config.orderUrl,
  '/api/stop': config.orderUrl,
  '/v1/api/room/updateStatus': config.roomUrl,
  '/api/order/oms/checkinV3': config.orderUrl,
  '/api/orderSource': config.orderUrl,
  '/api/discountType': config.orderUrl,
  '/api/v1/room_types/hotel_room_types': config.rubyUrl,
  '/api/v1/hotels/hotel_rooms': config.rubyUrl,
  '/api/v1/rates/rate_code_list': config.rubyUrl,
  '/api/v1/rates/create': config.rubyUrl,
  '/api/checkin/cancel': config.orderUrl,
  '/api/noAuth/openElong/getOmsHotelInfo': config.biUrl,
  '/api/notAuth/guangzhou/finApiSettlement/findSettlementDetailsTable': config.biUrl,
  // '/api/notAuth/guangzhou/finManagementOwnerEchar/countManagementTableInfos': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/countChainManageReportForXms': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/findManagementTableBaseInfo': config.biUrl,
  '/api/stop/list': config.orderUrl,
  '/api/checkiner/deleteCheckiner': config.orderUrl,
  '/api/order/orderDetail': config.orderUrl,
  '/api/pay/oms/getPayInfo': config.orderUrl,
  '/api/v1/clean_orders/room_list': config.xmsUrl,
  '/api/userInfo': config.userUrl,
  '/api/userInfo/getUserinfsByPhone': config.userUrl,
  '/api/checkin/checkout/getCheckOutMoney': config.orderUrl,
  '/api/pay/otherPaySuccess': config.orderUrl,
  '/api/consumption/getUnfinishConsumptions': config.orderUrl,
  '/api/checkin/checkout/checkMoney': config.orderUrl,
  '/api/checkin/overstay': config.orderUrl,
  '/api/checkin/cancelInfo': config.orderUrl,
  '/api/consumption/consumptionList/surplus': config.orderUrl,
  '/api/checkin/change': config.orderUrl,
  '/api/QiNiu/upload/getToken': config.toolUrl,
  '/api/v1/chains/my': config.xmsUrl,
  '/api/v1/orders/change_room': config.xmsUrl,
  '/api/v1/orders/checkout': config.xmsUrl,
  '/api/checkinInfo/findOne': config.orderUrl,
  '/api/payList/listByDate': config.orderUrl,
  '/api/refund/listByDate': config.orderUrl,
  '/api/orderTrail/orderNo': config.orderUrl,
  '/intelligent_reception/api/v1/reports/pays_export': config.xmsUrl,
  '/intelligent_reception/api/v1/reports/refunds_export': config.xmsUrl,
  '/api/refund/confirm': config.orderUrl,
  '/api/oms/changePassword': config.gateUrl,
  '/v2/lockApi/queryAllRock.do': config.doorLockUrl,
  '/lockApi/changeLock.do': config.doorLockUrl,
  '/lockApi/queryAllRockModel.do': config.doorLockUrl,
  '/lockApi/getLockOpenLogNew.do': config.doorLockUrl,
  '/lockApi/getLockPwdInfo.do': config.doorLockUrl,
  '/lockApi/resetLongRentPwd.do': config.doorLockUrl,
  '/lockApi/resetSuperPwd.do': config.doorLockUrl,
  '/lockApi/resetCustomerPwd.do': config.doorLockUrl,
  '/lockApi/resetRealTimePwd.do': config.doorLockUrl,
  '/lockApi/setRealTimePwd.do': config.doorLockUrl,
  '/lockApi/addOfflinePwd/byDuration': config.doorLockUrl,
  '/lockApi/addLongRentPwd.do': config.doorLockUrl,
  '/lockApi/updateLockState.do': config.doorLockUrl,
  '/lockApi/openRoomLock.do': config.doorLockUrl,
  '/roomInfo/chain': config.roomSysUrl,
  '/roomChain/searchChain': config.roomSysUrl,
  '/roomInfo/room': config.roomSysUrl,
  '/roomInfo/updateRoomBase.do': config.roomSysUrl,
  '/RoomTxt/roomId': config.roomSysUrl,
  '/RoomTxt/more': config.roomSysUrl,
  '/roomInfo/queryRoomFlack.do': config.roomSysUrl,
  '/roomInfo/updateRoomFlack.do': config.roomSysUrl,
  '/roomInfo/updateRoomFlackSn.do': config.roomSysUrl,
  '/roomInfo/removeRoomFlack.do': config.roomSysUrl,
  '/roomInfo/listRemoveRoomFlack': config.roomSysUrl,
  '/roomInfo/copyPicture/searchOtherRooms/all': config.roomSysUrl,
  '/roomInfo/copyPicture/toRooms': config.roomSysUrl,
  '/roomInfo/addRoomFlack.do': config.roomSysUrl,
  '/roomType/ota/getRoomTypeList': config.roomSysUrl,
  '/roomTypeBuffer/batchMod': config.roomSysUrl,
  '/api/v1/room_types/update': config.rubyUrl,
  '/api/v1/room_types/change': config.rubyUrl,
  '/api/notAuth/guangzhou/finApiSettlement/countSettlementDetailsTotalData': config.biUrl,
  '/api/notAuth/guangzhou/finApiSettlement/countFinSettlementRoomRevenueTotalData': config.biUrl,
  '/api/v1/tools/query_token': config.xmsUrl,
  '/admin/xbCleanOrderAction/query': config.cleanUrl,
  '/admin/xbCleanertAction/chainCleanerList': config.cleanUrl,
  '/admin/xbCleanOrderAction/xms/pushMessage': config.cleanUrl,
  '/admin/xbCleanOrderAction/cancelCleanOrder': config.cleanUrl,
  '/admin/xbCleanOrderAction/assignOrder': config.cleanUrl,
  '/admin/xbCleanOrderAction/add': config.cleanUrl,
  '/admin/xbCleanOrderAction/overCleanOrder': config.cleanUrl,
  '/api/hourRoom': config.orderUrl,
  '/api/hourRoom/chain': config.orderUrl,
  '/api/delayCheckout/listPage': config.orderUrl,
  '/api/delayCheckout/early': config.orderUrl,
  '/api/oms/user/subUsers': config.gateUrl,
  '/api/oms/user/subRoles': config.gateUrl,
  '/api/oms/role': config.gateUrl,
  '/api/oms/xms/user': config.gateUrl,
  '/api/oms/role/powers': config.gateUrl,
  '/api/oms/user/powers': config.gateUrl,
  '/api/oms/batchAddOmsUserRoomsRange': config.gateUrl,
  '/api/notAuth/guangzhou/finApiSettlement/findSettlementDetailsTableForXms': config.biUrl,
  '/api/dictValue/list': config.toolUrl,
  '/outConsumptions/xmsAccountsReport': config.accountUrl,
  '/outConsumptions/xmsChainMonthReport': config.accountUrl,
  '/settle/settleAccountDateList': config.accountUrl,
  '/manualRecord/add': config.accountUrl,
  '/profitMonth/list': config.accountUrl,
  '/profitMonth/export/': config.accountUrl,
  '/profitMonth/deatil/update': config.accountUrl,
  '/profitMonth/deatil/:id': config.accountUrl,
  '/profitMonth/deatil/refresh/:id': config.accountUrl,
  '/operationLog/list': config.accountUrl,
  '/dayProfixReport/list': config.accountUrl,
  '/admin/xbCleanertAction/bindCleanerList': config.cleanUrl,
  '/admin/xbCleanertAction/xmsBindChain': config.cleanUrl,
  '/admin/xbCleanertAction/unbindChain': config.cleanUrl,
  '/api/oms/logout': config.gateUrl,
  '/xms/api/v0/xbed_order_message/remind_messages': config.xmsUrl,
  '/api/notice/xmsNews': config.toolUrl,
  '/api/notice/xmsNewlist': config.toolUrl,
  '/api/notice/xmsNoticeRead': config.toolUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/countChainManageReportListForXms': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/exportChainManageReportListForXms': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/exportManagementTableBaseInfo': config.biUrl,
  '/api/invoice/includeElecInvoiceForXms': config.orderUrl,
  '/excel/exportInvoiceListForXms': config.analysisUrl,
  '/xms/api/pay/charges/show': config.xmsUrl,
  '/xms/api/pay/charges/retry': config.xmsUrl,
  '/api/source/priceCalculate': config.orderUrl,
  '/outConsumptions/xmsAccountsExport': config.accountUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/countChannelStatisticsForXms': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/selectRoomRentTypeList': config.biUrl,
  '/api/notAuth/guangzhou/finManagementOwnerEchar/exportRoomRentTypeList': config.biUrl,
  '/api/checkin/roomCheckinListForXms': config.orderUrl,
  '/api/checkin/roomNgintListForXms': config.orderUrl,
  '/excel/exportroomCheckinListForXms': config.analysisUrl,
  '/excel/exportroomNgintListForXms': config.analysisUrl,
  '/api/v1/room_types/batch_update': config.rubyUrl,
  '/api/v1/room_types/show': config.rubyUrl,
  '/roomChainManager': config.roomSysUrl,
  '/roomChainManager/dutyManager': config.roomSysUrl,
  '/api/xms/roomChainManager/changeDuty': config.gateUrl,
  '/api/xms/roomChainManager/overDuty': config.gateUrl,
  '/api/v1/rates/create_batch': config.rubyUrl,
  '/api/order/xms/findOrderPayDetial': config.orderUrl,
  '/api/order/xms/modifyBookingAmount': config.orderUrl,
  '/api/checkin/resetPwd': config.orderUrl,
  '/api/weiKong/selectElectricity': config.intelligentcsUrl,
  '/api/weiKong/applyElectricity': config.intelligentcsUrl,
}

export default ApiConfig


// WEBPACK FOOTER //
// ./src/api/groupConfig.js